import { render, staticRenderFns } from "./BoostCards.vue?vue&type=template&id=5b0f49d4&scoped=true"
import script from "./boost_cards.js?vue&type=script&lang=js&external"
export * from "./boost_cards.js?vue&type=script&lang=js&external"
import style0 from "./boost_cards.scss?vue&type=style&index=0&id=5b0f49d4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f49d4",
  null
  
)

export default component.exports